import React from 'react'
import useScreenWidth from '../../../../../Hooks/useScreenWidth'


export default function Logo({ url = '/logo.png', alwaysShowText = false, color = 'black' }) {

    return (
        <>
            <div className='logo' >
                <img src={url} alt='evolvion logo' />
                <h3 style={{ color: '#0D0D0D', textDecoration: 'none', color }} >ANCHORIZE</h3>
            </div>
        </>
    )
}
